export const personCircle = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M14 5.25C9.16751 5.25 5.25 9.16751 5.25 14C5.25 16.2254 6.08078 18.2568 7.44912 19.8009C8.73178 18.5773 11.1847 17.75 14 17.75C16.8153 17.75 19.2682 18.5773 20.5509 19.8009C21.9192 18.2568 22.75 16.2254 22.75 14C22.75 9.16751 18.8325 5.25 14 5.25ZM3.25 14C3.25 8.06294 8.06294 3.25 14 3.25C19.9371 3.25 24.75 8.06294 24.75 14C24.75 19.9371 19.9371 24.75 14 24.75C8.06294 24.75 3.25 19.9371 3.25 14ZM17.5 12C17.5 14.2091 15.933 16 14 16C12.067 16 10.5 14.2091 10.5 12C10.5 9.79086 12.067 8 14 8C15.933 8 17.5 9.79086 17.5 12Z"
    fill="currentColor"
  />
);
